import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/dilution-staking.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { DILUTION_STAKING } = getCurrentContractAddresses();
let contractReader = null;
let contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, DILUTION_STAKING);
  if (!contractReader) throw new Error("Failed to create dilution-staking contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  contractSender = new web3Sender.eth.Contract(ABI, DILUTION_STAKING);
  if (!contractSender) throw new Error("Failed to create dilution-staking contract sender");
  return contractSender;
}

async function balanceOf(owner) {
  const len = await getContractReader().methods.balanceOf(owner).call();
  return parseInt(len);
}

async function getArmyInfo(armyId) {
  const data = await getContractReader().methods.getArmyInfo(armyId).call();
  return data;
}

async function joinBattlefield(dispatch, tokenIds, stakeType, lockAmount, timeLock, accountAddress) {
  const estimatedGas = await getContractSender()
    .methods.joinBattlefield(tokenIds, stakeType, lockAmount, timeLock)
    .estimateGas({ from: accountAddress, gasPrice: 3000000000 });
  const iEstimatedGas = parseInt(estimatedGas);
  const emit = getContractSender()
    .methods.joinBattlefield(tokenIds, stakeType, lockAmount, timeLock)
    .send({ from: accountAddress, gas: 1500000 < iEstimatedGas ? iEstimatedGas : 1500000, gasPrice: 3000000000 });
  handleEmit(dispatch, emit, "Create battlefield");
  await emit;
}

async function withdrawAndClaimRewardBattlefield(dispatch, armyId, accountAddress) {
  const emit = getContractSender().methods.withdrawAndClaimRewardBattlefield(armyId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Withdraw knights and claim reward");
  await emit;
}

async function isApprovedForAll(owner, operator) {
  return await getContractReader().methods.isApprovedForAll(owner, operator).call();
}

async function setApprovalForAll(operator, accountAddress) {
  await getContractSender().methods.setApprovalForAll(operator, true).send({ from: accountAddress });
}

async function deployPrivateBattlefield(dispatch, tokenId, stakedAmount, accountAddress) {
  const emit = getContractSender()
    .methods.deployPrivateBattlefield(tokenId, stakedAmount)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Deploy limited battlefield");
  await emit;
}

async function privateBattleFieldId() {
  return await getContractReader().methods.privateBattleFieldId().call();
}

async function joinPrivateBattlefield(dispatch, armyId, knightId, lockAmount, accountAddress) {
  const emit = getContractSender()
    .methods.joinPrivateBattlefield(armyId, knightId, lockAmount)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Join limited battlefield");
  await emit;
}

async function withdrawPrivateBattlefield(dispatch, armyId, knightIds, accountAddress) {
  const emit = getContractSender().methods.withdrawPrivateBattlefield(armyId, knightIds).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Withdraw limited battlefield");
  await emit;
}

async function retreatPrivateBattlefield(dispatch, armyId, accountAddress) {
  const emit = getContractSender().methods.retreatPrivateBattlefield(armyId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Retreat limited battlefield");
  await emit;
}

export default {
  ABI,
  ADDRESS: DILUTION_STAKING,
  balanceOf,
  getArmyInfo,
  joinBattlefield,
  withdrawAndClaimRewardBattlefield,
  isApprovedForAll,
  setApprovalForAll,
  deployPrivateBattlefield,
  privateBattleFieldId,
  joinPrivateBattlefield,
  withdrawPrivateBattlefield,
  retreatPrivateBattlefield,
};
